import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Input } from "@/components/ui/input";
import api from "@/lib/api";
import { pickupPointsFor } from "@/lib/islands";

const OTHER = "__other__";
const SELECT_CLASS = "w-full h-11 rounded-xl border border-border bg-sand px-3 text-sm font-semibold text-ink focus:outline-none focus:ring-2 focus:ring-canard";

export function PickupSelect({ island, value, onChange, testid, placeholder, onCustom }) {
  const { t } = useTranslation();
  const [points, setPoints] = useState(() => pickupPointsFor(island));
  const [customFee, setCustomFee] = useState(0);
  const [other, setOther] = useState(Boolean(value) && !pickupPointsFor(island).includes(value));

  useEffect(() => {
    let done = false;
    if (!island) { setPoints(pickupPointsFor("")); setCustomFee(0); return undefined; }
    api.get(`/pickup-locations/${island}`).then((r) => {
      if (done) return;
      setPoints(r.data.points?.length ? r.data.points : pickupPointsFor(island));
      setCustomFee(r.data.custom_fee || 0);
    }).catch(() => { setPoints(pickupPointsFor(island)); setCustomFee(0); });
    return () => { done = true; };
  }, [island]);

  useEffect(() => { onCustom?.(other, customFee); }, [other, customFee]); // eslint-disable-line react-hooks/exhaustive-deps

  if (other) {
    return (
      <div className="flex items-center gap-2">
        <Input data-testid={testid} value={value} onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder || t("search.pickupOther")} className="h-11 rounded-xl bg-sand" />
        <button type="button" data-testid={`${testid}-back`} onClick={() => { setOther(false); onChange(""); }}
          className="text-sm font-bold text-canard hover:text-canard-dark shrink-0 px-1">↩</button>
      </div>
    );
  }

  return (
    <select data-testid={testid} value={points.includes(value) ? value : ""} className={SELECT_CLASS}
      onChange={(e) => { const val = e.target.value; if (val === OTHER) { setOther(true); onChange(""); } else onChange(val); }}>
      <option value="">{placeholder || t("search.pickupAny")}</option>
      {points.map((p) => <option key={p} value={p}>{p}</option>)}
      <option value={OTHER}>{t("search.pickupOther")}</option>
    </select>
  );
}
